import { FlexGridWrapper } from 'core-components/sitebuilder/layout/FlexGridWrapper'
import { useCurrentSitePage } from 'core-components/sitebuilder/layout/hooks/useCurrentSitePage'
import { IBaseLayout } from 'core-components/sitebuilder/models/IBaseLayout'

import styles from './LayoutClean.module.scss'

export const LayoutClean = (props: IBaseLayout) => {
  const sitePage = useCurrentSitePage()
  return (
    <FlexGridWrapper
      settingButtonVisible={true}
      className={styles.cleanroot}
      key={`flex-${sitePage.id}`}
    />
  )
}

export default LayoutClean
